"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.border = void 0;
var size_calculator_1 = require("../utils/size-calculator");
function border(color, baseFontSize, size) {
    if (baseFontSize === void 0) { baseFontSize = 16; }
    if (size === void 0) { size = 1; }
    return "".concat((0, size_calculator_1.sizeCalc)(size, baseFontSize), " solid ").concat(color);
}
exports.border = border;
